import React, { useCallback, useEffect, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { moveFormatter } from "../../fomatters/BooleanFormatter";
import Crud from "../Crud";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import InputSelect from "../InputSelect";
import Loader from "../loader/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const lineMap = [
  { value: 1, text: "Spread" },
  { value: 2, text: "Total" },
  { value: 3, text: "Money Line" },
];

/**
 * TABLE SYSTEMCOLORS
 */
function OddsBySport() {
  const [lineType, setLineType] = useState();
  const onLineTypeChanged = useCallback((lt) => setLineType(lt), []);
  const { values: lineTypes } = useDataFormatterHook({
    value: "idLineType",
    text: "description",
    path: `/LineType/GetLineTypes`,
  });

  const [gameType, setGameType] = useState();
  const onGameTypeChanged = useCallback((gt) => setGameType(gt), []);
  const { values: gameTypes } = useDataFormatterHook({
    value: "idGameType",
    text: "description",
    path: `/GameType/GameType_Get`,
  });

  const [sport, setSport] = useState();
  const onSportChanged = useCallback((s) => setSport(s), []);
  const { values: sports } = useDataFormatterHook({
    value: "idSport",
    text: "sportName",
    path: `/Player/GetSports`,
  });

  const [line, setLine] = useState(1);
  const onLineChanged = useCallback((l) => setLine(l), []);

  useEffect(() => {
    if (sports && gameTypes && lineTypes) {
      setLineType(lineTypes[0]?.value);
      setGameType(gameTypes[0]?.value);
      setSport(sports[0]?.value);
    }
  }, [sports, gameTypes, lineTypes]);

  if (!sports || !gameTypes || !lineTypes) return <Loader />;
  return (
    <div className="flex flex-col gap-4 h-max">
      <div className="vertical-options">
        <InputSelect
          variant="outlined"
          size="small"
          label="Line Type"
          name="name"
          data={lineTypes}
          placeholder="DataFormatter"
          setSelectValue={onLineTypeChanged}
          startValue={lineTypes?.[0]?.value}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Game Type"
          name="name"
          data={gameTypes}
          placeholder="DataFormatter"
          setSelectValue={onGameTypeChanged}
          startValue={gameTypes?.[0]?.value}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Sport"
          name="name"
          data={sports}
          placeholder="DataFormatter"
          setSelectValue={onSportChanged}
          startValue={sports?.[0]?.value}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Line"
          name="name"
          data={lineMap}
          placeholder="DataFormatter"
          setSelectValue={onLineChanged}
          startValue={line}
        />
      </div>
      <Crud
        className="unlock-overflow"
        title="Odds By Sport"
        getUrl={({ userId }) =>
          `/Profile/OddsBySport_GetList?idLineType=${lineType}&idGameType=${gameType}&idSport=${sport}&line=${line}&idUser=${userId}`
        }
        getProcess={(data) =>
          data.map((item) => ({
            IdComposed: `${item.idLineType}-${item.idGameType}-${item.idSport}-${item.line}-${item.range}`,
            ...item,
          }))
        }
        // INSERT
        insertUrl={() => "/Profile/OddsBySport_Insert"}
        insertValidate={(data, { range }, error) => {
          const alreadyExistsRange = data
            .map((item) => item.range)
            .includes(Number(range));
          if (alreadyExistsRange) {
            toast.error(`Range ${range} already exists`);
            return error(`Range ${range} already exists`);
          }
          return error();
        }}
        insertParams={({ userId }, { range, oddsValue }) => ({
          IdLineType: lineType,
          IdGameType: gameType,
          IdSport: sport,
          Line: line,
          Range: Number(range),
          OddsValue: Number(oddsValue),
          LastModificationUser: Number(userId),
        })}
        // UPDATE
        updateUrl={() => "/Profile/OddsBySport_Update"}
        updateParams={(
          { userId },
          { idLineType, idGameType, idSport, line, range, oddsValue }
        ) => ({
          IdLineType: Number(idLineType),
          IdGameType: Number(idGameType),
          IdSport: idSport,
          Line: Number(line),
          Range: Number(range),
          OddsValue: Number(oddsValue),
          LastModificationUser: Number(userId),
        })}
        // DELETE
        deleteUrl={() => "/Profile/OddsBySport_Delete"}
        deleteParams={(
          { userId },
          _,
          { idLineType, idGameType, idSport, line, range }
        ) => ({
          IdLineType: Number(idLineType),
          IdGameType: Number(idGameType),
          IdSport: idSport,
          Line: Number(line),
          Range: Number(range),
          LastModificationUser: Number(userId),
        })}
      >
        <TableHeaderColumn
          visible="none"
          hiddenOnInsert
          autoValue={true}
          hidden
          isKey
          dataField="IdComposed"
        >
          IdComposed
        </TableHeaderColumn>
        <TableHeaderColumn
          visible="none"
          hiddenOnInsert
          autoValue={true}
          hidden
          dataField="idLineType"
        >
          idLineType
        </TableHeaderColumn>
        <TableHeaderColumn
          visible="none"
          hiddenOnInsert
          autoValue={true}
          hidden
          dataField="idGameType"
        >
          idGameType
        </TableHeaderColumn>
        <TableHeaderColumn
          visible="none"
          hiddenOnInsert
          autoValue={true}
          hidden
          dataField="idSport"
        >
          idSport
        </TableHeaderColumn>
        <TableHeaderColumn
          visible="none"
          hiddenOnInsert
          autoValue={true}
          hidden
          dataField="line"
        >
          line
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="range"
          editable={() => false}
        >
          Range
        </TableHeaderColumn>
        <TableHeaderColumn dataField="oddsValue">Juice</TableHeaderColumn>
      </Crud>
      <ToastContainer position="top-right" autoClose={5000} />
    </div>
  );
}

export default OddsBySport;
